export const HeatPump = ({ power = true, mode = "heat", speed = 1, bladeRotation = null, glow = "#10a47a", width = 380 }) => {
  const spinning = power && bladeRotation === null;
  const dur = `${Math.max(0.25, 1.4 - speed)}s`;
  const modeColor = mode === "heat" ? "#e0592a" : "#2a7de0";
  return (
    <div className="hp-wrap" style={{ width, maxWidth: "100%" }}>
      <svg viewBox="0 0 440 320" width="100%" role="img" aria-label="Heat pump unit">
        <defs>
          <linearGradient id="hpBody" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#fdfdfe" /><stop offset="1" stopColor="#e8e7ef" />
          </linearGradient>
          <radialGradient id="hpFanBg" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#23214a" /><stop offset="1" stopColor="#17122e" />
          </radialGradient>
          <radialGradient id="hpAmbient" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor={glow} stopOpacity="0.35" /><stop offset="1" stopColor={glow} stopOpacity="0" />
          </radialGradient>
        </defs>

        <ellipse className="hp-glow" cx="220" cy="292" rx="200" ry="22" fill="url(#hpAmbient)" opacity={power ? 1 : 0.25} />

        <rect x="70" y="270" width="20" height="24" rx="4" fill="#c9c7d6" />
        <rect x="350" y="270" width="20" height="24" rx="4" fill="#c9c7d6" />

        <rect x="40" y="60" width="360" height="216" rx="22" fill="url(#hpBody)" stroke="#d4d2e0" strokeWidth="2" />
        <rect x="40" y="60" width="360" height="12" rx="6" fill="#ffffff" opacity="0.8" />

        {/* fan housing */}
        <circle cx="150" cy="168" r="86" fill="url(#hpFanBg)" stroke="#d4d2e0" strokeWidth="3" />
        <g
          className={`hp-blades ${spinning ? "spin" : ""}`}
          style={bladeRotation !== null
            ? { transform: `rotate(${bladeRotation}deg)`, transformOrigin: "150px 168px" }
            : { "--spin": dur, transformOrigin: "150px 168px", transformBox: "view-box" }}
        >
          {[0, 60, 120, 180, 240, 300].map((a) => (
            <path key={a} d="M150 168 C 150 128, 178 112, 196 120 C 186 146, 168 160, 150 168 Z"
              fill={power ? glow : "#4a4763"} opacity="0.92" transform={`rotate(${a} 150 168)`} />
          ))}
          <circle cx="150" cy="168" r="16" fill="#dcdae8" stroke="#b9b6cc" strokeWidth="2" />
        </g>
        {/* grille */}
        {[30, 52, 74].map((r) => (
          <circle key={r} cx="150" cy="168" r={r} fill="none" stroke="#8f8ba8" strokeWidth="1.6" opacity="0.55" />
        ))}
        {[0, 45, 90, 135].map((a) => (
          <line key={a} x1="150" y1="88" x2="150" y2="248" stroke="#8f8ba8" strokeWidth="1.6" opacity="0.55" transform={`rotate(${a} 150 168)`} />
        ))}
        <circle cx="150" cy="168" r="86" fill="none" stroke="#c2c0d2" strokeWidth="5" />

        {/* louvers */}
        {[92, 112, 132, 152, 172, 192, 212, 232].map((y) => (
          <line key={y} x1="262" y1={y} x2="378" y2={y} stroke="#c6c4d5" strokeWidth="5" strokeLinecap="round" />
        ))}

        {/* display */}
        <rect x="262" y="244" width="116" height="24" rx="6" fill="#17122e" />
        <text x="274" y="261" fontFamily="IBM Plex Mono, monospace" fontSize="13" fill={power ? modeColor : "#4a4763"} fontWeight="600">
          {power ? (mode === "heat" ? "HEAT 21.5°C" : "COOL 19.0°C") : "STANDBY"}
        </text>
        <circle cx="368" cy="256" r="4" fill={power ? glow : "#4a4763"}>
          {power && <animate attributeName="opacity" values="1;0.3;1" dur="1.6s" repeatCount="indefinite" />}
        </circle>

        <text x="262" y="82" fontFamily="IBM Plex Mono, monospace" fontSize="11" letterSpacing="2" fill="#8f8ba8">SWIFT ENERGY</text>

        {/* pipes */}
        <path d="M400 210 h 24 v 60" fill="none" stroke="#b9b6cc" strokeWidth="7" strokeLinecap="round" />
        <path d="M400 230 h 14 v 40" fill="none" stroke="#d4d2e0" strokeWidth="5" strokeLinecap="round" />

        {/* airflow */}
        <g className={`hp-air ${power ? "on" : ""}`}>
          {[[-30, 0.9], [0, 1], [30, 0.9]].map(([off, op], i) => (
            <path key={i} d={`M64 ${168 + off} C 30 ${168 + off}, 20 ${168 + off * 1.4}, -14 ${168 + off * 1.6}`}
              fill="none" stroke={modeColor} strokeWidth="3" strokeLinecap="round" opacity={op * 0.7} />
          ))}
        </g>
      </svg>
    </div>
  );
};
